import {FormSectionType} from '../../../../blocks/FormBlock'
import React from 'react'
import {copy} from '../../../../../util/fieldscopy'
import howYouKnowField from '../fields/howYouKnowField'
import questionsField from '../fields/questionsField'
import whereField from '../fields/whereField'

const sectionId: number = 1
const step3Section: FormSectionType = {
	id: sectionId,
	parent_id: 0,
	channel: 'section',
	label: copy?.communication || 'Communicatie',
	fields: [
		{
			id: 0,
			parent_id: sectionId,
			channel: 'text',
			name: 'intro',
			text: copy?.intro || '<h4>Hoe leerde jij {{eventName}} kennen?</h4>'
		},
		{...howYouKnowField, id: 1, parent_id: sectionId},
		{...whereField, id: 2, parent_id: sectionId},
		{
			id: 3,
			parent_id: sectionId,
			channel: 'text',
			name: 'imagery',
			text:
				copy?.imagery ||
				'<h4>Beeldmateriaal</h4><p>Al die sportieve gezelligheid leggen wij graag vast op de gevoelige plaat. Dit beeldmateriaal kan later gebruikt worden ter promotie van onze sportieve evenementen – zowel online (website, sociale media) als offline (brochures, tijdschrift, jaarverslag). Geef je hiervoor geen toestemming? Stuur dan een mailtje naar <a href="mailto:toni.vancanneyt@broederlijkdelen.be">toni.vancanneyt@broederlijkdelen.be</a>.</p>'
		},
		{...questionsField, id: 4, parent_id: sectionId}
	]
}

export default step3Section
